import './portfolio.css';

import CarouselIndustries from './carouselIndustries/carouselIndustries';
import Customers from './customers/customers';
import Cloud from './cloud/cloud';
import Calculator from './calculator/calculator';

export default function Portfolio({isMobile}) {
    return(
        <div className="portfolio">
            <CarouselIndustries isMobile={isMobile}/>
            <Customers isMobile={isMobile}/>
            <Cloud isMobile={isMobile}/>
            <Calculator/>
        </div>
    )
};